import { config } from "../config";

function UpdateParentWindow(state, updateState) {
    const isEmbeddedInFrame = _inIframe();
    const isEmbeddedInFrame2 = window.location !== window.parent.location;
    const urlHash = createUrlHash(state)

    // This branch is used so that it works properly in dev/test environments.
    window.history.pushState({}, "", `/#${urlHash}`);
}

function _inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function createUrlHash(state) {
    let hash = 'phase' + state.phase + '|' +
               state.implementationModel + '|' +
               (state.selectedFundings.length ? state.selectedFundings.join(',') + '|' : '|') +
               state.investmentSize + '|' +
               state.payBackTime + '|' +
               state.completionYear + '|' +
               state.varsLoanInterest + '|' +
               state.varsGreenLoanInterest + '|' +
               state.varsShortRentInitialRent + '|' +
               state.varsShortRentIndexing + '|' +
               state.varsShortRentRedemptionValue + '|' +
               state.varsLongRentInitialRent + '|' +
               state.varsLongRentIndexing + '|' +
               state.varsLongRentRedemptionValue + '|' +
               state.varsLeasingInterest + '|' +
               state.varsLeasingResidualValue + '|' +
               state.varsLeasingContractTime + '|' +
               state.varsGreenLeasingInterest + '|' +
               state.varsGreenLeasingResidualValue + '|' +
               state.varsGreenLeasingContractTime;
    return hash;
}

export default UpdateParentWindow;
export { createUrlHash }
